import { IClaimTypeSubType } from "./claim-type-sub-type.model";

export interface IClaimType {
  claimTypeId: string;
  code: string;
  nameEnglish: string;
  nameArabic: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string | null;
  deletedDate: string | null;
  claimTypeSubTypes: IClaimTypeSubType[];
}

export const claimTypeConfig = {
  entityName: 'CONFIGURATION.CLAIM_TYPE.TITLE',
  code: 'FORM_FIELD.CODE',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  claimSubTypes: 'CONFIGURATION.CLAIM_TYPE.SUB_TYPES'
};